import React from 'react';

import InsufficientCreditsModal from '../views/modal/InsufficientCreditsModal';
import { MappingAccessDenied } from '../utils/mappingAccess';

type MappingAccessCreditsModalProps = {
    info: MappingAccessDenied | null;
    modalId: string;
    modalRef: React.RefObject<HTMLSpanElement>;
    onClose: () => void;
    isOwner: boolean;
    adminEmail?: string;
};

export function MappingAccessCreditsModal({
    info,
    modalId,
    modalRef,
    onClose,
    isOwner,
    adminEmail,
}: MappingAccessCreditsModalProps) {
    if (!info) {
        return null;
    }

    return (
        <>
            <span ref={modalRef} data-bs-target={`#${modalId}`} data-bs-toggle="modal" />
            <InsufficientCreditsModal
                id={modalId}
                creditsRequired={info.creditsRequired}
                creditsAvailable={info.creditsAvailable}
                deficit={info.deficit}
                plan={info.plan}
                onClose={onClose}
                isOwner={isOwner}
                adminEmail={adminEmail}
            />
        </>
    );
}
